import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Legend, Tooltip } from "recharts";
import CHART_COLORS from "./chartColors";

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
	if (percent < 0.05) return null; // Don't show labels for very small slices

	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text
			x={x}
			y={y}
			fill="white"
			textAnchor={x > cx ? "start" : "end"}
			dominantBaseline="central"
			fontSize={12}
			fontWeight="bold"
		>
			{`${(percent * 100).toFixed(0)}%`}
		</text>
	);
};

const DonutChart = ({ question, results }) => {
	// Transform results data for the chart
	const chartData = results.responses.map((response, index) => ({
		name: question.responses?.find(r => r.key === response.responseKey)?.title || response.responseKey,
		value: response.count,
		percentage: response.percentage,
	}));

	return (
		<div className="chart-container donut-chart">
			<div className="chart-header">
				<h4>{question.title}</h4>
				{question.subtitle && <p className="chart-subtitle">{question.subtitle}</p>}
			</div>

			<div className="chart-content">
				<ResponsiveContainer width="100%" height={400}>
					<PieChart>
						<Pie
							data={chartData}
							cx="50%"
							cy="50%"
							labelLine={false}
							label={renderCustomizedLabel}
							outerRadius={120}
							innerRadius={60}
							dataKey="value"
						>
							{chartData.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
							))}
						</Pie>
						<Tooltip
							formatter={(value, name) => [
								`${value} ${value === 1 ? "vote" : "votes"} (${(
									(value / results.totalVotes) *
									100
								).toFixed(1)}%)`,
								name,
							]}
							labelStyle={{ display: "none" }}
						/>
						<Legend />
					</PieChart>
				</ResponsiveContainer>
			</div>

			<div className="chart-footer">Total Votes: {results.totalVotes}</div>
		</div>
	);
};

export default DonutChart;
